import { useState } from 'react';
import useToken from 'hooks/useToken';
import { useToast } from 'context/providers/ToastProvider';

/**
 * Hook para manejar las acciones del lead (actualizar campos, etapas, etc.)
 * @param {Object} detallesLead - Detalles del lead actual
 * @param {Function} setDetallesLead - Función para actualizar detalles del lead
 * @param {Array} contactos - Lista de contactos
 * @param {Function} setContactos - Función para actualizar contactos
 * @param {Function} GuardarComentario - Función para guardar comentarios
 * @param {Function} guardarNotificacion - Función para guardar notificaciones
 * @param {Function} crearObjAction - Función para crear objeto de acción
 * @returns {Object} Objeto con estados y funciones para acciones del lead
 * @returns {boolean} return.editarNombreLead - Estado de edición de nombre
 * @returns {Function} return.setEditarNombreLead - Actualiza estado de edición de nombre
 * @returns {boolean} return.editarGiroComercial - Estado de edición de giro comercial
 * @returns {Function} return.setEditarGiroComercial - Actualiza estado de edición de giro
 * @returns {boolean} return.editarCorreo - Estado de edición de correo
 * @returns {Function} return.setEditarCorreo - Actualiza estado de edición de correo
 * @returns {boolean} return.editarPropuestaEconomica - Estado de edición de P.E.
 * @returns {Function} return.setEditarPropuestaEconomica - Actualiza estado de edición de P.E.
 * @returns {boolean} return.editarSource - Estado de edición de source
 * @returns {Function} return.setEditarSource - Actualiza estado de edición de source
 * @returns {boolean} return.editarEtapaModal - Estado de edición de etapa
 * @returns {Function} return.setEditarEtapaModal - Actualiza estado de edición de etapa
 * @returns {Function} return.actualizarNombreLead - Actualiza el nombre del lead
 * @returns {Function} return.actualizarGiroComercial - Actualiza el giro comercial
 * @returns {Function} return.ActualizarFuente - Actualiza la fuente/source del lead
 */
export const useLeadActions = (detallesLead, setDetallesLead, contactos, setContactos, GuardarComentario, guardarNotificacion, crearObjAction) => {
    const { token, setToken, idUsuario, nombreCompleto } = useToken();
    const { showErrorToast, showSuccessToast } = useToast();

    const [editarNombreLead, setEditarNombreLead] = useState(false);
    const [editarGiroComercial, setEditarGiroComercial] = useState(false);
    const [editarCorreo, setEditarCorreo] = useState(false);
    const [editarPropuestaEconomica, setEditarPropuestaEconomica] = useState(false);
    const [editarSource, setEditarSource] = useState(false);
    const [editarEtapaModal, setEditarEtapaModal] = useState(false);

    const actualizarNombreLead = async (Modal_NombreLead) => {
        var jDataSend = {
            vNombreLead: Modal_NombreLead,
            idLead: detallesLead.idLead
        };

        const response = await fetch("/api/leads/actualizarNombreLead/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                var detalles = JSON.parse(data.detalles);

                GuardarComentario("Modificó el nombre del lead de <b>" + detallesLead.vNombreLead + "</b> a <b>" + detalles.vNombreLead + "</b>", "2", detallesLead.idLead);

                if (contactos !== null && typeof contactos !== 'undefined') {
                    var currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                    if (currentLeadIndex == -1) {
                        var detalleslead_Copy = { ...detallesLead, vNombreLead: detalles.vNombreLead };
                        setContactos([detalleslead_Copy, ...contactos]);
                    } else {
                        const updatedContactos = [...contactos];
                        updatedContactos[currentLeadIndex] = { ...updatedContactos[currentLeadIndex], iDaysDiff: 0, vNombreLead: detalles.vNombreLead };
                        setContactos(updatedContactos);
                    }
                }

                if (idUsuario != detallesLead.idUsuario) {
                    var objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                    guardarNotificacion("Cambio de nombre de Lead",
                        "<b> " + nombreCompleto + "</b> ha cambiado el nombre del lead <b>#" + detallesLead.idLead + "</b> : <i> '" + Modal_NombreLead.substring(0, 3) + "...'</i>",
                        detallesLead.idUsuario,
                        objToActionString,
                        2);
                }

                setDetallesLead({
                    ...detallesLead,
                    vNombreLead: detalles.vNombreLead
                });

                setEditarNombreLead(false);
                showSuccessToast("Cambio de Nombre de Lead exitoso");
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const actualizarGiroComercial = async (Modal_GiroComercial) => {
        var jDataSend = {
            vGiroComercial: Modal_GiroComercial,
            idLead: detallesLead.idLead
        };

        const response = await fetch("/api/leads/actualizarGiroComercial/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                var detalles = JSON.parse(data.detalles);

                GuardarComentario("Modificó el giro comercial de <b>" + detallesLead.vGiroComercial + "</b> a <b>" + detalles.vGiroComercial + "</b>", "2", detallesLead.idLead);

                if (contactos !== null && typeof contactos !== 'undefined') {
                    var currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                    if (currentLeadIndex == -1) {
                        var detalleslead_Copy = { ...detallesLead, vGiroComercial: detalles.vGiroComercial };
                        setContactos([detalleslead_Copy, ...contactos]);
                    } else {
                        const updatedContactos = [...contactos];
                        updatedContactos[currentLeadIndex] = { ...updatedContactos[currentLeadIndex], iDaysDiff: 0, vGiroComercial: detalles.vGiroComercial };
                        setContactos(updatedContactos);
                    }
                }

                if (idUsuario != detallesLead.idUsuario) {
                    var objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                    guardarNotificacion("Cambio de giro comercial de Lead",
                        "<b> " + nombreCompleto + "</b> ha cambiado el giro comercial del lead <b>#" + detallesLead.idLead + "</b> : <i> '" + Modal_GiroComercial.substring(0, 1) + "...'</i>",
                        detallesLead.idUsuario,
                        objToActionString,
                        2);
                }

                setDetallesLead({
                    ...detallesLead,
                    vGiroComercial: detalles.vGiroComercial
                });

                setEditarGiroComercial(false);
                showSuccessToast("Cambio de Giro Comercial exitoso");
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const ActualizarFuente = async (Source) => {
        var idSource = 0;
        if (Source == "WhatsApp") idSource = 1;
        if (Source == "Messenger") idSource = 2;
        if (Source == "Facebook") idSource = 3;
        if (Source == "Tawk") idSource = 4;
        if (Source == "Correo") idSource = 5;
        if (Source == "AkasiaBot") idSource = 6;
        if (Source == "Distribuidor") idSource = 7;

        const response = await fetch("/api/leads/ActualizarFuente/?idLead=" + detallesLead.idLead + "&idSource=" + idSource, {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            }
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();
            if (data.iResponseType == 1) {
                var detalles = JSON.parse(data.detalles);

                GuardarComentario("Se ha determinado que este lead viene desde: <img src='/img/leads/" + Source + "48.png' width='30'></img> <b>" + Source + "</b>", "2", detallesLead.idLead);

                setDetallesLead({
                    ...detallesLead,
                    idSource: idSource
                });

                if (contactos !== null && typeof contactos !== 'undefined') {
                    const currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);
                    if (currentLeadIndex !== -1) {
                        const updatedContactos = [...contactos];
                        updatedContactos[currentLeadIndex] = { ...updatedContactos[currentLeadIndex], idSource: idSource };
                        setContactos(updatedContactos);
                    }
                }

                showSuccessToast(detalles.vMessage);
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                location.href = "";
            }
        }
    };

    const actualizarCorreo = async (Modal_Correo) => {
        const jDataSend = {
            vCorreo: Modal_Correo,
            idLead: detallesLead.idLead
        };

        const response = await fetch("/api/leads/actualizarCorreo/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                const detalles = JSON.parse(data.detalles);

                GuardarComentario("Modificó el correo de <b>" + detallesLead.vCorreo + "</b> a <b>" + detalles.vCorreo + "</b>", "2", detallesLead.idLead);

                if (contactos !== null && typeof contactos !== 'undefined') {
                    const currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                    if (currentLeadIndex == -1) {
                        const detalleslead_Copy = { ...detallesLead, vCorreo: detalles.vCorreo };
                        setContactos([detalleslead_Copy, ...contactos]);
                    } else {
                        const updatedContactos = [...contactos];
                        updatedContactos[currentLeadIndex] = { ...updatedContactos[currentLeadIndex], iDaysDiff: 0, vCorreo: detalles.vCorreo };
                        setContactos(updatedContactos);
                    }
                }

                if (idUsuario != detallesLead.idUsuario) {
                    const objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                    guardarNotificacion("Cambio de correo de Lead",
                        "<b> " + nombreCompleto + "</b> ha cambiado el correo del lead <b>#" + detallesLead.idLead + "</b> : <i> '" + Modal_Correo.substring(0, 6) + "...'</i>",
                        detallesLead.idUsuario,
                        objToActionString,
                        2);
                }

                setDetallesLead({
                    ...detallesLead,
                    vCorreo: detalles.vCorreo
                });

                setEditarCorreo(false);
                showSuccessToast("Cambio de Correo exitoso");
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                window.location.href = "";
            }
        }
    };

    const actualizarPropuestaEconomica = async (Modal_PropuestaEconomica, Modal_Moneda) => {
        if (Modal_Moneda === "") {
            showErrorToast("Selecciona una Moneda para guardar la propuesta economica");
            return;
        }

        const jDataSend = {
            dPropuestaEconomica: Modal_PropuestaEconomica,
            vMoneda: Modal_Moneda,
            idLead: detallesLead.idLead
        };

        const response = await fetch("/api/leads/actualizarPropuestaEconomica/", {
            method: 'POST',
            headers: {
                'Authorization': 'Bearer ' + token,
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jDataSend)
        }).catch((error) => {
            showErrorToast('Hubo un problema con la peticion Fetch:' + error);
        });

        if (response.ok) {
            const data = await response.json();

            if (data.iResponseType == 1) {
                const detalles = JSON.parse(data.detalles);

                GuardarComentario("Modificó la propuesta económica de <b>" + detallesLead.dPropuestaEconomica + " " + detallesLead.vMoneda + "</b> a <b>" + detalles.dPropuestaEconomica + " " + detalles.vMoneda + "</b>", "2", detallesLead.idLead);

                if (contactos !== null && typeof contactos !== 'undefined') {
                    const currentLeadIndex = contactos.findIndex((lead) => lead.idLead === detallesLead.idLead);

                    if (currentLeadIndex == -1) {
                        const detalleslead_Copy = {
                            ...detallesLead,
                            dPropuestaEconomica: detalles.dPropuestaEconomica,
                            vMoneda: detalles.vMoneda
                        };
                        setContactos([detalleslead_Copy, ...contactos]);
                    } else {
                        contactos[currentLeadIndex].iDaysDiff = 0;
                        contactos[currentLeadIndex].dPropuestaEconomica = detalles.dPropuestaEconomica;
                        contactos[currentLeadIndex].vMoneda = detalles.vMoneda;
                    }
                }

                if (idUsuario != detallesLead.idUsuario) {
                    const objToActionString = crearObjAction(1, '', 1, detallesLead.idLead);
                    guardarNotificacion("Cambio de propuesta economica de Lead",
                        "<b> " + nombreCompleto + "</b> ha cambiado la P.E. del lead <b>#" + detallesLead.idLead + "</b> : <i> '" + Modal_PropuestaEconomica.toString().substring(0, 4) + " " + Modal_Moneda + "'</i>",
                        detallesLead.idUsuario,
                        objToActionString,
                        2);
                }

                setDetallesLead({
                    ...detallesLead,
                    dPropuestaEconomica: detalles.dPropuestaEconomica,
                    vMoneda: detalles.vMoneda
                });

                setEditarPropuestaEconomica(false);
                showSuccessToast("Cambio de Propuesta Económica exitoso");
            } else {
                showErrorToast(data.vMessage);
            }
        } else {
            showErrorToast(response.status + ' ' + response.statusText);
            if (response.status == 401) {
                setToken(null);
                window.location.href = "";
            }
        }
    };

    return {
        editarNombreLead,
        setEditarNombreLead,
        editarGiroComercial,
        setEditarGiroComercial,
        editarCorreo,
        setEditarCorreo,
        editarPropuestaEconomica,
        setEditarPropuestaEconomica,
        editarSource,
        setEditarSource,
        editarEtapaModal,
        setEditarEtapaModal,
        actualizarNombreLead,
        actualizarGiroComercial,
        actualizarCorreo,
        actualizarPropuestaEconomica,
        ActualizarFuente
    };
};
